import { useEffect } from 'react';
import ExerciseClock from '../components/cc/ExerciseClock';
import ForceDisposition from '../components/cc/ForceDisposition';
import CommsPanel from '../components/cc/CommsPanel';
import FeedList from '../components/cc/FeedList';
import KpiTicker from '../components/cc/KpiTicker';
import ReportsPanel from '../components/reports/ReportsPanel';
import { useTargetStore } from '../store/targetStore';
import { usePlatoonStore } from '../store/platoonStore';

export default function CommandCenterPage() {
  const fetchTargets = useTargetStore((s) => s.fetchTargets);
  const fetchPlatoons = usePlatoonStore((s) => s.fetchPlatoons);

  useEffect(() => {
    fetchTargets();
    fetchPlatoons();
    const t = setInterval(() => {
      fetchTargets();
      fetchPlatoons();
    }, 10000);
    return () => clearInterval(t);
  }, [fetchTargets, fetchPlatoons]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="min-w-0">
          <h1 className="text-lg font-display font-bold text-gray-100">Command Center</h1>
          <p className="text-gray-500 text-[11px]">Tempo · force status · comms</p>
        </div>
        {/* Scrolls on narrow screens instead of clipping */}
        <div className="max-w-full overflow-x-auto [-webkit-overflow-scrolling:touch]">
          <div className="w-max">
            <KpiTicker />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <ExerciseClock />
        <ForceDisposition />
        <CommsPanel />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <FeedList compact />
        <ReportsPanel compact limit={12} />
      </div>
    </div>
  );
}
